// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/build/src/models/settings/store';
import model_2 from '/build/src/models/shared-values/store';

export const models = {
model_1: { namespace: "settings.store", model: model_1 },
model_2: { namespace: "shared-values.store", model: model_2 },
} as const
